import FisheryIconNormal from '../../../assets/images/map_icons/Blue.png';
import GoogleMapReact from 'google-map-react';
import React from 'react';

export function MapWithAddressPin({ address, disableInteraction = false }) {
  const Marker = () => {
    return (
      <div className='map_location_pin'>
        <img
          style={{ width: '40px' }}
          src={FisheryIconNormal}
          alt='Fishing all day'
        />
      </div>
    );
  };

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
      defaultCenter={{
        lat: address.location.lat,
        lng: address.location.lng,
      }}
      defaultZoom={10}
      options={{
        gestureHandling: disableInteraction ? 'none' : 'greedy',
        fullscreenControl: !disableInteraction,
        zoomControl: !disableInteraction,
      }}
    >
      <Marker lat={address.location.lat} lng={address.location.lng} />
    </GoogleMapReact>
  );
}
